import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="front-footer">
      <div className="container">
        <div className="row">
          <div className="col-md-2">
            <div className="footer-box footer-logo-box">
              <a className="navbar-brand" href="#">
                <img
                  src="/assets/images/logo.png"
                  alt="img"
                  className="img-fluid"
                />
              </a>
              <p className="text-light">{t("footer.description")}</p>
            </div>
          </div>
          <div className="col-6 col-md-2">
            <div className="footer-box">
              <h4> {t("footer.topRestaurants.title")}</h4>
              <ul className="p-0 m-0">
                <li>
                  <a href="#">{t("footer.topRestaurants.restaurant1")}</a>
                </li>
                <li>
                  <a href="#">{t("footer.topRestaurants.restaurant2")}</a>
                </li>
                <li>
                  <a href="#">{t("footer.topRestaurants.restaurant3")}</a>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-6 col-md-2">
            <div className="footer-box">
              <h4>{t("footer.services.title")}</h4>
              <ul className="p-0 m-0">
                <li>
                  <a href="#">{t("footer.services.lecture")}</a>
                </li>
                <li>
                  <a href="#">{t("footer.services.arrival")}</a>
                </li>
                <li>
                  <a href="#">{t("footer.services.readingKoran")}</a>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-6 col-md-2">
            <div className="footer-box">
              <h4>{t("footer.company.title")}</h4>
              <ul className="p-0 m-0">
                <li>
                  <a href="#">{t("footer.company.aboutUs")}</a>
                </li>
                <li>
                  <Link to={`/ContactUs`}>{t("footer.company.contactUs")}</Link>
                </li>
                <li>
                  <a href="#">{t("footer.company.career")}</a>
                </li>
                <li>
                  <a href="#">{t("footer.company.team")}</a>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-6 col-md-2">
            <div className="footer-box">
              <h4>{t("footer.legal.title")}</h4>
              <ul className="p-0 m-0">
                <li>
                  <Link to={`/TermsandCondition`}>
                    {t("footer.legal.termsConditions")}
                  </Link>
                  <a href="#"></a>
                </li>
                <li>
                  <Link to={`/CookiePolicy`}>
                    {t("footer.legal.cookiePolicy")}
                  </Link>
                  <a href="#"></a>
                </li>
                <li>
                  <Link to={`/PrivacyPolicy`}>
                    {t("footer.legal.privacyPolicy")}
                  </Link>
                </li>
                <li>
                  <Link to={`/ServiceProvider`}>
                    {t("footer.legal.serviceProviderTerms")}
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-6 col-md-2">
            <div className="footer-box">
              <h4>{t("footer.followUs")}</h4>
              <div className="footer-social">
                <a href="#">
                  <i className="fab fa-facebook-square"></i>
                </a>
                <a href="#">
                  <i className="fab fa-twitter-square"></i>
                </a>
                <a href="#">
                  <i className="fab fa-instagram-square"></i>
                </a>
                <a href="#">
                  <i className="fab fa-linkedin"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="bottom-footer">
          <p className="m-0">{t("footer.copyright")}</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
